import { render, staticRenderFns } from "./subDeptList.vue?vue&type=template&id=f8a3ebe0"
import script from "./subDeptList.vue?vue&type=script&lang=js"
export * from "./subDeptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports